import { useFormikContext } from "formik";
import { ProtocolResponse } from "../../models/dtos";
import CustomDropdown from "../../components/forms/CustomDropdown";
import { teachersApi } from "../../services/teachers/teachersApi";
import { Button } from "primereact/button";
import CustomInputText from "../../components/forms/CustomInputText";
import { Card } from "primereact/card";

const ProtocolCommission = () => {
  const { data: teachers } = teachersApi.useGetTeachersQuery({});
  const { values, setFieldValue } = useFormikContext<ProtocolResponse>();

  const handleMemberChange = (index: number, teacherId: number | null, teacherName: string | null = null) => {
    const updatedMembers = [...values.protocolTeachers];
    updatedMembers[index] = {
      protocolId: values.protocolId,
      teacherId: teacherId,
      teacherName: teacherName,
      orderNumber: index + 1,
    };
    setFieldValue("protocolTeachers", updatedMembers);
  };

  return (
    <Card>
      {values.protocolTeachers?.map((member, index) => (
        <div key={index} className="flex flex-row justify-content-start gap-2">
          <div className="flex-1">
            <CustomDropdown
              id={`protocolTeacher-${index}`}
              label={`Преподавател ${index + 2}`}
              options={teachers?.data || []}
              optionLabel={(option) =>
                `${option.firstName} ${option.middleName} ${option.lastName} - ${option.academicPositionShortName || ""} ${
                  option.academicRankShortName || ""
                } - ${option.departmentFacultyShortName || ""}`
              }
              optionValue="teacherId"
              filter
              value={member?.teacherId}
              onChange={(e: any) => handleMemberChange(index, e.value)}
            />
          </div>
          <div className="flex-1">
            <CustomInputText
              id={`protocolTeacherName-${index}`}
              label="Име (за външни членове)"
              placeholder="Въведете име"
              value={member?.teacherName || ""}
              onChange={(e: any) => handleMemberChange(index, null, e.target.value)}
            />
          </div>
          <Button
            type="button"
            icon="pi pi-trash"
            severity="danger"
            onClick={() => {
              const updatedMembers = values.protocolTeachers.filter((_, i) => i !== index);
              const reorderedMembers = updatedMembers.map((member, idx) => ({
                ...member,
                orderNumber: idx + 1,
              }));
              setFieldValue("protocolTeachers", reorderedMembers);
            }}
          />
        </div>
      ))}
      <Button
        type="button"
        icon="pi pi-plus"
        onClick={() =>
          setFieldValue("protocolTeachers", [
            ...values.protocolTeachers,
            {
              protocolId: values.protocolId,
              teacherId: null,
              teacherName: null,
              orderNumber: values.protocolTeachers.length + 1,
            },
          ])
        }
      ></Button>
    </Card>
  );
};

export default ProtocolCommission;
